"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tooltip = _interopRequireDefault(require("britive-design-system/core/components/tooltip"));

var _dialog = _interopRequireDefault(require("britive-design-system/core/components/dialog"));

var _typography = _interopRequireDefault(require("britive-design-system/core/components/typography"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _bs = require("react-icons/bs");

var _browserPonyfill = require("@github/webauthn-json/browser-ponyfill");

var _reactRouterDom = require("react-router-dom");

var _DataTable = _interopRequireDefault(require("../../../../../../components/data-table/DataTable"));

var _commonConstants = require("../../../../../../utils/common-constants");

var _commonUtils = require("../../../../../../utils/common-utils");

var _utils = require("../../utils");

var _constants = require("../constants");

var _constants2 = require("./constants");

var _SecretApprovalModal = _interopRequireDefault(require("../../secret-approval-modal/SecretApprovalModal"));

var _WaitingApprovalDialog = _interopRequireDefault(require("../../../../../../common-widgets/waiting-approval-dialog/WaitingApprovalDialog"));

var _externalization = require("../../../../externalization");

var _utils2 = require("../../../../../secret-manager/modules/secrets/utils");

var _SecretViewModal = require("./components/SecretViewModal");

var _StepUpModal = _interopRequireDefault(require("../../../../../../components/StepUpModal"));

var _constants3 = require("../../../../../../components/StepUpModal/constants");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var styles = "/* Add custom scrollbar style for Chrome, Safari, FF and Edge */\n.my-secrets-secret-view-loader {\n  position: absolute;\n  top: 60%;\n  left: 50%;\n  transform: translate(-60%, -50%); }\n\n.secret-view-user-settings-link {\n  color: var(--brand);\n  display: inline;\n  cursor: pointer; }\n\n.my-secrets-secret-view-layout .secret-view-spacing:not(:last-child) {\n  margin-bottom: 2.5rem; }\n\n.my-secrets-secret-view-layout .secret-view-label {\n  margin-bottom: 0.5rem;\n  color: #393939;\n  display: flex;\n  justify-content: space-between;\n  height: 1rem; }\n  .my-secrets-secret-view-layout .secret-view-label .sm-my-secrets-copy-value {\n    display: flex; }\n\n.my-secrets-secret-view-layout .typography-label-02 {\n  color: #393939; }\n\n.my-secrets-secret-view-layout .typography-label-01 {\n  color: #525252; }\n\n.my-secrets-secret-view-layout .secret-view-value {\n  max-width: 25rem;\n  color: #525252; }\n  .my-secrets-secret-view-layout .secret-view-value .sm-my-secret-param-link {\n    width: 100%;\n    text-decoration: none;\n    color: #525252; }\n  .my-secrets-secret-view-layout .secret-view-value .sm-my-secret-param-link:hover {\n    width: 100%;\n    text-decoration: underline;\n    color: #067fdb; }\n  .my-secrets-secret-view-layout .secret-view-value .masked-action-buttons {\n    display: flex;\n    margin-bottom: 0.5rem; }\n    .my-secrets-secret-view-layout .secret-view-value .masked-action-buttons .show-button {\n      margin-right: 1rem; }\n\n.my-secrets-secret-view-layout .field-wrapper {\n  margin-top: 2rem; }\n  .my-secrets-secret-view-layout .field-wrapper:first-child {\n    margin-top: 0; }\n  .my-secrets-secret-view-layout .field-wrapper .field-value-wrapper {\n    margin-top: 0.5rem; }\n    .my-secrets-secret-view-layout .field-wrapper .field-value-wrapper .file-buttons-wrapper {\n      display: flex;\n      flex-direction: row; }\n      .my-secrets-secret-view-layout .field-wrapper .field-value-wrapper .file-buttons-wrapper > button {\n        display: flex; }\n      .my-secrets-secret-view-layout .field-wrapper .field-value-wrapper .file-buttons-wrapper > button:first-child {\n        margin-right: 1rem; }\n\n.my-secrets-secret-view-layout .secret-value-render {\n  display: flex;\n  justify-content: space-between;\n  height: 1rem; }\n\n.my-secrets-approval-pending-popup-field-spacing {\n  margin-top: 0.5rem; }\n\n.sm-my-secret-view-file-loading-error {\n  width: fit-content;\n  margin-bottom: 1rem;\n  margin-top: 1rem; }\n\n.details-action-button-container {\n  display: flex;\n  gap: 0.5rem; }\n";
  var fileName = "secr_MySecretList";
  var element = document.querySelector("style[data-sass-component='secr_MySecretList']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var SecretList = function SecretList(_ref) {
  var _secretDetailError$da;

  var secretListLoading = _ref.secretListLoading,
      getSecretList = _ref.getSecretList,
      secretListData = _ref.secretListData,
      secretListPagination = _ref.secretListPagination,
      selectedItemAncestors = _ref.selectedItemAncestors,
      vaultId = _ref.vaultId,
      getSecretDetails = _ref.getSecretDetails,
      getAuthenticateStepUpMFA = _ref.getAuthenticateStepUpMFA,
      flushStepUpMFA = _ref.flushStepUpMFA,
      secretDetailStatus = _ref.secretDetailStatus,
      secretDetailData = _ref.secretDetailData,
      secretTemplateDetailStatus = _ref.secretTemplateDetailStatus,
      secretTemplateDetailError = _ref.secretTemplateDetailError,
      secretTemplateData = _ref.secretTemplateData,
      openNotification = _ref.openNotification,
      getSecretLoadMoreList = _ref.getSecretLoadMoreList,
      updateSecretListSearchTerm = _ref.updateSecretListSearchTerm,
      secretSearchTerm = _ref.secretSearchTerm,
      secretDetailError = _ref.secretDetailError,
      resetSecretDetails = _ref.resetSecretDetails,
      secretDownloadedFile = _ref.secretDownloadedFile,
      secretFileDownloadStatus = _ref.secretFileDownloadStatus,
      secretFileDownloadStatusCode = _ref.secretFileDownloadStatusCode,
      secretFileDownloadError = _ref.secretFileDownloadError,
      getSecretFile = _ref.getSecretFile,
      fetchNewOTP = _ref.fetchNewOTP,
      resetOTP = _ref.resetOTP,
      otp = _ref.otp,
      secretOTPFetchStatus = _ref.secretOTPFetchStatus,
      secretOTPFetchError = _ref.secretOTPFetchError,
      secretDetailsLoadTime = _ref.secretDetailsLoadTime,
      secretTemplateLoadTime = _ref.secretTemplateLoadTime,
      secretOTPFetchLoadTime = _ref.secretOTPFetchLoadTime,
      mfaAuthenticate = _ref.mfaAuthenticate,
      initiateWebAuthnAuthentication = _ref.initiateWebAuthnAuthentication,
      getUserMFAStatus = _ref.getUserMFAStatus,
      fetchUserMFAStatusStatus = _ref.fetchUserMFAStatusStatus,
      fetchUserMFAStatusData = _ref.fetchUserMFAStatusData,
      webAuthnAuthenticationInitialDataStatus = _ref.webAuthnAuthenticationInitialDataStatus,
      webAuthnAuthenticationInitialData = _ref.webAuthnAuthenticationInitialData,
      authenticateWebAuthN = _ref.authenticateWebAuthN,
      resetStartWebAuthnAuthentication = _ref.resetStartWebAuthnAuthentication,
      resetFetchUserMFAStatus = _ref.resetFetchUserMFAStatus;
  var history = (0, _reactRouterDom.useHistory)();

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      secretTableData = _useState2[0],
      setSecretTableData = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      openViewSecretModal = _useState4[0],
      setOpenViewSecretModal = _useState4[1];

  var _useState5 = (0, _react.useState)(''),
      _useState6 = _slicedToArray(_useState5, 2),
      secretViewName = _useState6[0],
      setSecretViewName = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      openWaitingForApprovalDialog = _useState8[0],
      setOpenWaitingForApprovalDialog = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      showNoMfaDialog = _useState10[0],
      setShowNoMfaDialog = _useState10[1];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = _slicedToArray(_useState11, 2),
      openRequiredApprovalModal = _useState12[0],
      setOpenRequiredApprovalModal = _useState12[1];

  var _useState13 = (0, _react.useState)(),
      _useState14 = _slicedToArray(_useState13, 2),
      isApprovalPendingAfterApprovalSent = _useState14[0],
      setIsApprovalPendingAfterApprovalSent = _useState14[1];

  var _useState15 = (0, _react.useState)(secretDetailError === null || secretDetailError === void 0 ? void 0 : (_secretDetailError$da = secretDetailError.data) === null || _secretDetailError$da === void 0 ? void 0 : _secretDetailError$da.extraInfo),
      _useState16 = _slicedToArray(_useState15, 2),
      approversDetails = _useState16[0],
      setApproversDetails = _useState16[1];

  var _useState17 = (0, _react.useState)(),
      _useState18 = _slicedToArray(_useState17, 2),
      clickedSecret = _useState18[0],
      setClickedSecret = _useState18[1];

  var _useState19 = (0, _react.useState)(),
      _useState20 = _slicedToArray(_useState19, 2),
      clickedFileSecret = _useState20[0],
      setFileClickedSecret = _useState20[1];

  var _useState21 = (0, _react.useState)(false),
      _useState22 = _slicedToArray(_useState21, 2),
      isSearchEmpty = _useState22[0],
      setSearchEmpty = _useState22[1];

  var _useState23 = (0, _react.useState)(null),
      _useState24 = _slicedToArray(_useState23, 2),
      file = _useState24[0],
      setFile = _useState24[1];

  var _useState25 = (0, _react.useState)({
    visible: false,
    availableMfaModes: []
  }),
      _useState26 = _slicedToArray(_useState25, 2),
      stepUpModal = _useState26[0],
      setStepUpModal = _useState26[1];

  var _useState27 = (0, _react.useState)({
    path: '',
    name: ''
  }),
      _useState28 = _slicedToArray(_useState27, 2),
      secretsPath = _useState28[0],
      setSecretsPath = _useState28[1];

  var onClose = function onClose() {
    setStepUpModal({
      visible: false,
      availableMfaModes: []
    });
    flushStepUpMFA();
    resetStartWebAuthnAuthentication();
    resetFetchUserMFAStatus();
  };

  (0, _react.useEffect)(function () {
    if ((mfaAuthenticate === null || mfaAuthenticate === void 0 ? void 0 : mfaAuthenticate.result) !== 'SUCCEEDED') return;
    var isStepUpError = _constants2.secretListConstants.stepUpErrorCode;

    if ((secretFileDownloadError === null || secretFileDownloadError === void 0 ? void 0 : secretFileDownloadError.errorCode) === isStepUpError) {
      getSecretFile(clickedFileSecret, vaultId);
    } else if ((secretOTPFetchError === null || secretOTPFetchError === void 0 ? void 0 : secretOTPFetchError.errorCode) === isStepUpError) {
      fetchNewOTP(secretsPath === null || secretsPath === void 0 ? void 0 : secretsPath.path);
    } else {
      handleViewSecret(secretsPath === null || secretsPath === void 0 ? void 0 : secretsPath.path, secretsPath === null || secretsPath === void 0 ? void 0 : secretsPath.name);
    }

    onClose();
  }, [mfaAuthenticate, secretDetailError, secretFileDownloadError, secretOTPFetchError]);
  (0, _react.useEffect)(function () {
    if (fetchUserMFAStatusStatus === 'SUCCESS') {
      var getFactorStatus = function getFactorStatus(factor) {
        var _fetchUserMFAStatusDa;

        return (fetchUserMFAStatusData === null || fetchUserMFAStatusData === void 0 ? void 0 : (_fetchUserMFAStatusDa = fetchUserMFAStatusData.find(function (item) {
          return item.factor === factor;
        })) === null || _fetchUserMFAStatusDa === void 0 ? void 0 : _fetchUserMFAStatusDa.status) || 'UNREGISTERED';
      };

      if (fetchUserMFAStatusData.length === 0 && secretViewName !== '') {
        setShowNoMfaDialog(true);
        return;
      }

      var totpStatus = getFactorStatus(_constants3.mfaFactor.totp);
      var webauthnStatus = getFactorStatus(_constants3.mfaFactor.webAuthN);

      if (totpStatus === 'REGISTERED' && webauthnStatus === 'REGISTERED') {
        setStepUpModal({
          visible: true,
          availableMfaModes: [_constants3.mfaFactor.totp, _constants3.mfaFactor.webAuthN]
        });
      } else if (totpStatus !== 'REGISTERED' && webauthnStatus === 'REGISTERED') {
        validateWebAuthn();
      } else if (totpStatus === 'REGISTERED' && webauthnStatus !== 'REGISTERED') {
        setStepUpModal({
          visible: true,
          availableMfaModes: [_constants3.mfaFactor.totp]
        });
      } else {
        setStepUpModal({
          visible: true,
          availableMfaModes: [_constants3.mfaFactor.webAuthN]
        });
      }
    }
  }, [fetchUserMFAStatusStatus, fetchUserMFAStatusData]);
  (0, _react.useEffect)(function () {
    if (webAuthnAuthenticationInitialDataStatus === 'SUCCESS') {
      handleAuthenticateViaWebAuthN(webAuthnAuthenticationInitialData);
    }
  }, [webAuthnAuthenticationInitialDataStatus, webAuthnAuthenticationInitialData]);
  (0, _react.useEffect)(function () {
    var _secretDetailError$da2;

    var isStepUpError = _constants2.secretListConstants.stepUpErrorCode;

    if ((secretDetailError === null || secretDetailError === void 0 ? void 0 : (_secretDetailError$da2 = secretDetailError.data) === null || _secretDetailError$da2 === void 0 ? void 0 : _secretDetailError$da2.errorCode) === isStepUpError || (secretOTPFetchError === null || secretOTPFetchError === void 0 ? void 0 : secretOTPFetchError.errorCode) === isStepUpError || (secretFileDownloadError === null || secretFileDownloadError === void 0 ? void 0 : secretFileDownloadError.errorCode) === isStepUpError) {
      getRegisteredMFADevices();
    }
  }, [secretDetailError, secretOTPFetchError, secretFileDownloadError]);

  var validateOtp = function validateOtp(mfaOtp) {
    getAuthenticateStepUpMFA(_constants3.mfaFactor.totp, {
      otp: mfaOtp
    });
  };

  var validateWebAuthn = function validateWebAuthn() {
    initiateWebAuthnAuthentication();
  };

  var getRegisteredMFADevices = function getRegisteredMFADevices() {
    getUserMFAStatus();
  };

  var handleAuthenticateViaWebAuthN = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(webAuthnInitialData) {
      var _webAuthnInitialData$, requestOptions, publicKeyCredential;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              requestOptions = (0, _browserPonyfill.parseRequestOptionsFromJSON)(JSON.parse(webAuthnInitialData === null || webAuthnInitialData === void 0 ? void 0 : (_webAuthnInitialData$ = webAuthnInitialData.additionalDetails) === null || _webAuthnInitialData$ === void 0 ? void 0 : _webAuthnInitialData$.requestOptionsJson));
              _context.next = 4;
              return (0, _browserPonyfill.get)(requestOptions);

            case 4:
              publicKeyCredential = _context.sent;
              authenticateWebAuthN(webAuthnInitialData, publicKeyCredential);
              _context.next = 13;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);

              if (!['AbortError', 'NotAllowedError'].includes(_context.t0.name)) {
                _context.next = 12;
                break;
              }

              return _context.abrupt("return", null);

            case 12:
              openNotification('error', 'Something went wrong while trying to initiate WebAuthn', 300);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));

    return function handleAuthenticateViaWebAuthN(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleViewSecret = function handleViewSecret(path, name) {
    resetSecretDetails();
    getSecretDetails(path, {});
    setSecretViewName(name);
    setOpenViewSecretModal(true);
    setIsApprovalPendingAfterApprovalSent(); //clickedSecret will store appropriate array for path to the secret which is clicked

    var clickedSecret = [];
    var pathArray = path === null || path === void 0 ? void 0 : path.split('/');

    for (var i = 0; i < (pathArray === null || pathArray === void 0 ? void 0 : pathArray.length); i++) {
      clickedSecret.push({
        label: pathArray[i]
      });
    }

    setFileClickedSecret(pathArray);
    clickedSecret.splice(-1, 1);
    setClickedSecret(clickedSecret);
  };

  var handleSecretSearch = (0, _react.useCallback)((0, _debounce.default)(function (nextValue) {
    updateSecretListSearchTerm(nextValue);
    setSearchEmpty(!nextValue);
    /* To make get all call for empty search value */

    !nextValue && getSecretList(selectedItemAncestors.slice(1));
  }, _constants2.searchDebounceTime), [] // will be created only once initially
  );
  (0, _react.useEffect)(function () {
    if (!(0, _isEmpty.default)(vaultId)) {
      updateSecretListSearchTerm('');
      setSearchEmpty(true);
      Boolean(selectedItemAncestors.length) && getSecretList(selectedItemAncestors.slice(1));
    }
  }, [selectedItemAncestors]);
  (0, _react.useEffect)(function () {
    if ((0, _commonUtils.isError)(secretDetailStatus) || (0, _commonUtils.isError)(secretTemplateDetailStatus)) {
      var _secretDetailError$da6, _secretDetailError$da7;

      if ((0, _commonUtils.isError)(secretDetailStatus)) {
        var _secretDetailError$da3, _secretDetailError$da5;

        if ((secretDetailError === null || secretDetailError === void 0 ? void 0 : secretDetailError.status) === 403 && (secretDetailError === null || secretDetailError === void 0 ? void 0 : (_secretDetailError$da3 = secretDetailError.data) === null || _secretDetailError$da3 === void 0 ? void 0 : _secretDetailError$da3.errorCode) === _constants2.secretListConstants.approvalRequiredErrorCode_11) {
          var _secretDetailError$da4;

          setOpenRequiredApprovalModal(true);
          setApproversDetails(secretDetailError === null || secretDetailError === void 0 ? void 0 : (_secretDetailError$da4 = secretDetailError.data) === null || _secretDetailError$da4 === void 0 ? void 0 : _secretDetailError$da4.extraInfo);
          return;
        }

        if ((secretDetailError === null || secretDetailError === void 0 ? void 0 : secretDetailError.status) === 403 && (secretDetailError === null || secretDetailError === void 0 ? void 0 : (_secretDetailError$da5 = secretDetailError.data) === null || _secretDetailError$da5 === void 0 ? void 0 : _secretDetailError$da5.errorCode) === _constants2.secretListConstants.pendingSecretErrorCode_10) {
          if (isApprovalPendingAfterApprovalSent) {
            setOpenWaitingForApprovalDialog(false);
            return;
          }

          setOpenWaitingForApprovalDialog(true);
          return;
        }
      }

      var reason = (secretDetailError === null || secretDetailError === void 0 ? void 0 : (_secretDetailError$da6 = secretDetailError.data) === null || _secretDetailError$da6 === void 0 ? void 0 : _secretDetailError$da6.message) || (secretDetailError === null || secretDetailError === void 0 ? void 0 : secretDetailError.message) || (secretTemplateDetailError === null || secretTemplateDetailError === void 0 ? void 0 : secretTemplateDetailError.message);

      if ((secretDetailError === null || secretDetailError === void 0 ? void 0 : (_secretDetailError$da7 = secretDetailError.data) === null || _secretDetailError$da7 === void 0 ? void 0 : _secretDetailError$da7.errorCode) !== _constants2.secretListConstants.stepUpErrorCode) {
        openNotification(_commonConstants.errorNotificationType, (0, _externalization.translate)('SECRETS_MODULE.DETAILS_FAILURE_MESSAGE', {
          reason: reason
        }), _commonConstants.errorNotificationDuration);
      }
    }
  }, [secretDetailStatus, secretTemplateDetailStatus, isApprovalPendingAfterApprovalSent]);
  (0, _react.useEffect)(function () {
    if (secretSearchTerm) {
      getSecretList(selectedItemAncestors.slice(1));
    }
  }, [secretSearchTerm]);
  (0, _react.useEffect)(function () {
    var tableData = secretListData.map(function (secret) {
      var name = secret.name,
          description = secret.description,
          path = secret.path,
          status = secret.status;
      return {
        name: name,
        description: description,
        path: path,
        status: (0, _utils.getSecretStatus)(status)
      };
    });
    setSecretTableData(tableData);
  }, [secretListData]);
  (0, _react.useEffect)(function () {
    if ((0, _commonUtils.isSuccess)(secretTemplateDetailStatus) && secretTemplateData && (0, _utils2.doesTemplateContainsFileField)(secretTemplateData)) {
      getSecretFile(clickedFileSecret, vaultId);
    }
  }, [secretTemplateData, secretTemplateDetailStatus]);
  (0, _react.useEffect)(function () {
    if (secretDetailStatus === _commonConstants.RESOURCE_STATUS.ERROR || secretTemplateDetailStatus === _commonConstants.RESOURCE_STATUS.ERROR) {
      // Close the Secret Detail Modal if API gets error
      setOpenViewSecretModal(false);
      resetSecretDetails();
    }
  }, [secretDetailStatus, secretTemplateDetailStatus]);
  (0, _react.useEffect)(function () {
    if ((0, _commonUtils.isSuccess)(secretFileDownloadStatus) && (0, _commonUtils.isSuccess)(secretDetailStatus) && (0, _commonUtils.isSuccess)(secretTemplateDetailStatus) && secretDetailData && secretTemplateData && !(0, _isEmpty.default)(secretDetailData.value)) {
      var fileSSTParameter = (0, _utils2.getFileSSTParameter)(secretTemplateData.parameters);

      if (fileSSTParameter && fileSSTParameter.name && secretDetailData.value[fileSSTParameter.name]) {
        var fileName = secretDetailData.value[fileSSTParameter.name];
        var _file = null;

        if (_commonConstants.allImageFormats.includes((0, _utils2.getFileExtension)(fileName))) {
          _file = new File([secretDownloadedFile], fileName, {
            type: (0, _utils2.getImageFileType)(fileName)
          });
        } else {
          _file = new File([secretDownloadedFile], fileName);
        }

        setFile(_file);
      }
    }
  }, [secretFileDownloadStatus, secretDetailStatus, secretTemplateDetailStatus, secretDetailData, secretTemplateData]);

  var reloadSecretFile = function reloadSecretFile() {
    return getSecretFile(clickedFileSecret, vaultId);
  };

  var secretsColumns = [{
    width: '25%',
    field: 'name',
    headerName: _constants2.translatedStrings.secretsNameColumnHeader,
    horizontalAlignment: 'left',
    sortable: true
  }, {
    width: '27%',
    field: 'description',
    headerName: _constants2.translatedStrings.secretsDescriptionColumnHeader,
    horizontalAlignment: 'left'
  }, {
    width: '30%',
    field: 'path',
    headerName: _constants2.translatedStrings.secretsPathColumnHeader,
    horizontalAlignment: 'left',
    sortable: true
  }, {
    width: '18%',
    field: 'status',
    headerName: _constants2.translatedStrings.secretsStatusColumnHeader,
    horizontalAlignment: 'left',
    sortable: true
  }, {
    headerName: _constants2.translatedStrings.secretsActionColumnHeader,
    width: '152px',
    renderColumn: function renderColumn(row) {
      var status = row.status,
          path = row.path,
          name = row.name;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: _constants.classes.secretsEyeIcon
      }, status !== _constants2.secretListConstants.accessDenyText ? /*#__PURE__*/_react.default.createElement(_tooltip.default, {
        title: _constants2.translatedStrings.viewSecretTooltip,
        position: _constants2.secretListConstants.leftText
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_bs.BsEye, {
        onClick: function onClick() {
          handleViewSecret(path, name);
          setSecretsPath({
            path: path,
            name: name
          });
        },
        size: _constants2.iconSize,
        "data-testid": "view-icon"
      }))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_tooltip.default, {
        title: _constants2.translatedStrings.accessDeniedText,
        position: _constants2.secretListConstants.leftText
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_bs.BsEye, {
        className: _constants2.classes.disabledIcon,
        size: _constants2.iconSize
      })))));
    }
  }];

  var copyAllHandler = function copyAllHandler() {
    var _secretTemplateData$p;

    var secretData = ["".concat(_constants2.translatedStrings.secretNameLabel, " = ").concat(secretDetailData === null || secretDetailData === void 0 ? void 0 : secretDetailData.name), "".concat(_constants2.translatedStrings.secretDescriptionLabel, " = ").concat((secretDetailData === null || secretDetailData === void 0 ? void 0 : secretDetailData.description) || _constants2.translatedStrings.noneText)];
    secretTemplateData === null || secretTemplateData === void 0 ? void 0 : (_secretTemplateData$p = secretTemplateData.parameters) === null || _secretTemplateData$p === void 0 ? void 0 : _secretTemplateData$p.map(function (parameter) {
      for (var name in secretDetailData === null || secretDetailData === void 0 ? void 0 : secretDetailData.value) {
        if (parameter.type !== _commonUtils.otpType && (parameter === null || parameter === void 0 ? void 0 : parameter.name) === name) secretData.push("".concat(name, " = ").concat(secretDetailData === null || secretDetailData === void 0 ? void 0 : secretDetailData.value[name]));
      }
    });
    secretTemplateData.parameters.find(function (el) {
      return el.type === _commonUtils.otpType;
    }) && secretData.push("OTP = ".concat(otp || (secretDetailData === null || secretDetailData === void 0 ? void 0 : secretDetailData.value[_commonUtils.otpName])));
    var secretDataString = secretData.join('\n');
    navigator.clipboard.writeText(secretDataString);
    openNotification(_constants2.secretListConstants.successText, _constants2.translatedStrings.copyNotificationMessage, _constants2.copyNotificationTime);
  };

  var onCloseHandler = function onCloseHandler() {
    setSecretViewName('');
    setOpenViewSecretModal(false);
    resetSecretDetails();
    resetOTP();
  };

  var secretViewActionButtons = [{
    text: _constants2.translatedStrings.copyAllText,
    variant: _constants2.secretListConstants.priVariant,
    onClick: copyAllHandler,
    size: _constants2.secretListConstants.largeSize
  }, {
    text: _constants2.translatedStrings.closeText,
    variant: _constants2.secretListConstants.secVariant,
    onClick: onCloseHandler,
    size: _constants2.secretListConstants.largeSize
  }];

  var loadMoreHandler = function loadMoreHandler() {
    getSecretLoadMoreList(selectedItemAncestors.slice(1));
  };

  var handleApprovalModal = function handleApprovalModal(isApprovalPending) {
    setOpenRequiredApprovalModal(false);

    if (isApprovalPending) {
      setIsApprovalPendingAfterApprovalSent(isApprovalPending);
      getSecretList(selectedItemAncestors.slice(1));
    }
  };

  var handleWaitingApprovalDialog = function handleWaitingApprovalDialog(isOpen) {
    setOpenWaitingForApprovalDialog(isOpen);
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "all-secrets-table",
    className: _constants.classes.secretsTabTableContainer
  }, /*#__PURE__*/_react.default.createElement(_DataTable.default, {
    inLineSort: true,
    rows: secretTableData,
    columns: secretsColumns,
    loading: secretListLoading,
    loadingMessage: _constants2.translatedStrings.secretsLoadingMessage,
    loadMoreHandler: loadMoreHandler,
    loadMore: !secretListLoading && Boolean(secretListPagination === null || secretListPagination === void 0 ? void 0 : secretListPagination.next),
    searchBar: {
      onSearch: handleSecretSearch,
      placeholder: _constants2.translatedStrings.searchPlaceholderText,
      isSearchEmpty: isSearchEmpty
    }
  }), openViewSecretModal && /*#__PURE__*/_react.default.createElement(_SecretViewModal.SecretViewModal, {
    secretDetailStatus: secretDetailStatus,
    secretTemplateDetailStatus: secretTemplateDetailStatus,
    secretDetailData: secretDetailData,
    secretTemplateData: secretTemplateData,
    secretViewActionButtons: secretViewActionButtons,
    secretViewName: secretViewName,
    onCloseHandler: onCloseHandler,
    file: file,
    secretFileDownloadStatus: secretFileDownloadStatus,
    secretFileDownloadStatusCode: secretFileDownloadStatusCode,
    reloadSecretFile: reloadSecretFile,
    fetchNewOTP: fetchNewOTP,
    otp: otp,
    secretOTPFetchStatus: secretOTPFetchStatus,
    secretOTPFetchError: secretOTPFetchError,
    selectedItemAncestors: selectedItemAncestors,
    secretDetailsLoadTime: secretDetailsLoadTime,
    secretTemplateLoadTime: secretTemplateLoadTime,
    secretOTPFetchLoadTime: secretOTPFetchLoadTime,
    secretFileDownloadError: secretFileDownloadError
  }), openWaitingForApprovalDialog && /*#__PURE__*/_react.default.createElement(_WaitingApprovalDialog.default, {
    handleWaitingApprovalDialog: handleWaitingApprovalDialog,
    translatedStringsForWaitingApproval: _constants2.translatedStringsForWaitingApproval
  }), openRequiredApprovalModal && /*#__PURE__*/_react.default.createElement(_SecretApprovalModal.default, {
    vaultId: vaultId,
    secretName: secretViewName,
    selectedItemAncestors: clickedSecret,
    handleApprovalModal: handleApprovalModal,
    approversDetails: approversDetails,
    translatedStringsForApprovalsModal: _constants2.translatedStringsForApprovalsModal
  }), showNoMfaDialog && /*#__PURE__*/_react.default.createElement(_dialog.default, {
    type: "alert",
    title: 'MFA Registration Required',
    secondaryButtonText: 'Close',
    onCancel: function onCancel() {
      return setShowNoMfaDialog(false);
    }
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "body"
  }, "To proceed with viewing a Secret, MFA registration is required. Please go to", /*#__PURE__*/_react.default.createElement("div", {
    className: _constants2.classes.secretViewUserSettingsLink,
    onClick: function onClick() {
      return history.push('/user-settings');
    }
  }, ' ', "User Settings", ' '), "and register an MFA device.")), stepUpModal.visible && /*#__PURE__*/_react.default.createElement(_StepUpModal.default, {
    secretMode: "view",
    onClose: onClose,
    mfaAuthenticate: mfaAuthenticate,
    availableMfaModes: stepUpModal.availableMfaModes,
    validateOtp: validateOtp,
    validateWebAuthn: validateWebAuthn
  }));
};

SecretList.propTypes = {
  secretListLoading: _propTypes.default.bool,
  getSecretList: _propTypes.default.func,
  secretListData: _propTypes.default.array,
  secretListPagination: _propTypes.default.func,
  selectedItemAncestors: _propTypes.default.array,
  vaultId: _propTypes.default.string,
  getSecretDetails: _propTypes.default.func,
  getAuthenticateStepUpMFA: _propTypes.default.func,
  flushStepUpMFA: _propTypes.default.func,
  secretDetailStatus: _propTypes.default.oneOf(_commonConstants.typeOfStatus),
  secretDetailData: _propTypes.default.object,
  secretTemplateDetailStatus: _propTypes.default.oneOf(_commonConstants.typeOfStatus),
  secretTemplateData: _propTypes.default.object,
  openNotification: _propTypes.default.func,
  getSecretLoadMoreList: _propTypes.default.func,
  updateSecretListSearchTerm: _propTypes.default.func,
  secretSearchTerm: _propTypes.default.string,
  getUsersStatus: _propTypes.default.oneOf(_commonConstants.typeOfStatus),
  initSpinnerOverlay: _propTypes.default.func,
  secretDetailError: _propTypes.default.any,
  secretTemplateDetailError: _propTypes.default.any,
  getGroupsStatus: _propTypes.default.oneOf(_commonConstants.typeOfStatus),
  selectionHandler: _propTypes.default.func,
  resetSecretDetails: _propTypes.default.func,
  secretDownloadedFile: _propTypes.default.any,
  secretFileDownloadStatus: _propTypes.default.string,
  secretFileDownloadStatusCode: _propTypes.default.number,
  secretFileDownloadError: _propTypes.default.string,
  getSecretFile: _propTypes.default.func,
  fetchNewOTP: _propTypes.default.func,
  resetOTP: _propTypes.default.func,
  otp: _propTypes.default.string,
  secretOTPFetchStatus: _propTypes.default.string,
  secretOTPFetchError: _propTypes.default.string,
  secretDetailsLoadTime: _propTypes.default.number,
  secretTemplateLoadTime: _propTypes.default.number,
  secretOTPFetchLoadTime: _propTypes.default.number,
  mfaAuthenticate: _propTypes.default.object,
  fetchUserMFAStatusStatus: _propTypes.default.string,
  fetchUserMFAStatusData: _propTypes.default.object,
  initiateWebAuthnAuthentication: _propTypes.default.func,
  getUserMFAStatus: _propTypes.default.func,
  webAuthnAuthenticationInitialDataStatus: _propTypes.default.string,
  webAuthnAuthenticationInitialData: _propTypes.default.object,
  authenticateWebAuthN: _propTypes.default.func,
  resetStartWebAuthnAuthentication: _propTypes.default.func,
  resetFetchUserMFAStatus: _propTypes.default.func
};
var _default = SecretList;
exports.default = _default;